<template>

    <div class="col-xs-12 col-md-3">
        <template v-if="inputType === 'select'">
            <div class="label-wrapper">
                <label v-bind:for="uniq_id">{{labelName}}</label>
            </div>
            <div class="form-group c-input" v-bind:class="css">
                <select class="form-control"
                        @change="saveValue"
                        v-bind:id="uniq_id"
                        v-model="value"
                        v-bind="dataAttr">
                    <option v-for="(option,index) in sortOptions(extension.options)" v-bind:value="option.value" :key="option.value" v-bind:selected="index == 0">
                        {{option.label}}
                    </option>
                </select>
            </div>
        </template>
        <template v-else-if="inputType === 'gps'">
            <div class="label-wrapper">
                <label v-bind:for="uniq_id">{{labelName}} </label>
            </div>
            <div class="input-group form-group c-input"
                 v-bind:class="css">
<!--
                <span class="input-group-btn">
                    <button class="btn btn-default" type="button" v-on:click="undo()" @blur="saveValue" disabled>
                        <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"> </span>
                    </button>
                </span>
-->
                <span class="input-group">
                    <div>
                        <input class="form-control"
                               type="text"
                               v-bind:id="uniq_id"
                               v-bind="dataAttr"
                               v-model="gps"
                                :placeholder="this.translate('Permission.gps.hint')"
                               @blur="saveValue"
                               @keyup.enter="saveValue">
                    </div>
                </span>
                <span class="input-group-btn">
                    <button class="btn btn-success" type="button" >
                        &nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>&nbsp;
                    </button>
                </span>
            </div>
        </template>
        <template v-else-if="inputType === 'tag'">
            <div class="label-wrapper">
                <label v-bind:for="uniq_id">{{labelName}}</label>
            </div>
            <div class="input-group form-group c-input"
                 v-bind:class="css">
                <multiselect-input
                        v-model="value"
                        v-bind:options="options"
                        @change="multiselectChange"
                />
            </div>
        </template>
        <template v-else-if="inputType === 'immutable' || (inputType === 'casVzniku' && !isEventWaitting)">
            <label v-bind:for="uniq_id">{{labelName}}</label>
            <div class="input-group form-group c-input"
                 v-bind:class="css">
                <span class="input-group">
                    {{value}}
                </span>
            </div>
        </template>
        <template v-else>
            <div class="label-wrapper">
                <label v-bind:for="uniq_id">{{labelName}}</label>
            </div>
            <div class="input-group form-group c-input"
                 v-bind:class="css">
                <span class="input-group-btn">
                    <button class="btn btn-default" type="button" v-on:click="undo()" @blur="saveValue">
                        <span class="glyphicon glyphicon-arrow-left" aria-hidden="true"> </span>
                    </button>
                </span>
                <input class="form-control"
                       v-bind:id="uniq_id"
                       v-bind:type="inputType"
                       v-bind:min="inputNumberMin"
                       v-bind="dataAttr"
                       v-model="value"

                       @blur="saveValue"
                       @keyup.enter="saveValue">
                <span class="input-group-btn">
                    <button class="btn btn-success" type="button">
                        &nbsp;<span class="glyphicon glyphicon-ok" aria-hidden="true"></span>&nbsp;
                    </button>
                </span>
            </div>
        </template>

    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    import multiselectInput from '../components/multiselectInput'
    import GpsFormat from "../utils/GpsFormat";
    import getPropertyValue from "./getPropertyValue";

    export default {
        components: {
            multiselectInput
        },
        name: "formMixin",
        data: function () {
            return {
                uniq_id: null,
                change: null,
                prevChange: null,
                cssClass: {
                    'c-input--success': false,
                    'c-input--error': false,
                    'c-input--disable': false,
                    'c-input--scenario-val': false,
                },
                changes: [],
                allowCreateNew: false,
                allowDelete: false
            }
        },
        props: {
            inputType: String, // set 'select'
            inputNumberMin: Number,
            labelName: String,
            dataEntityId: Number,
            dataProperty: String,
            dataAttr: Object,
            dataCss: Object,
        },
        watch: {
            baseId(zakladna) {
                if (this.$props.inputType === 'gps' && zakladna !== undefined) {
                    this.getEntities(this.getSimId).then(entities => {
                        let bases = entities.filter(entity => entity.type === 'zakladna');
                        let selectedBase = bases.filter(base => base.entityId === getPropertyValue(this.$props.entity, 'zakladna'))[0];
                        if (selectedBase !== undefined) {
                            let baseCoord = getPropertyValue(selectedBase, 'gpsLatLng');
                            this.gps = baseCoord.toString();
                            this.saveValue();
                        }
                    });
                }
            }
        },
        methods: {
            async saveValue() {
                if (this.value !== this.prevValue) {

                    this.prevValue = this.value;
                    this.changes.push(this.value);
                    this.disable();
                    let entityId = this.dataEntityId,
                        property = this.dataProperty,
                        value = this.value,
                        changeId = this.changeId;

                    try {
                        await this.sendChange(entityId, property, value, changeId);
                        this.success();
                        this.change = null;
                        setTimeout(this.clear, 800);
                        this.$eventHub.$emit('openMessageController', 'success', this.translate('Popups.text19'));
                    } catch (e) {
                        this.error();
                        setTimeout(this.clear, 800);
                        console.log('Saving was not successful:', e);
                        this.$eventHub.$emit('openMessageController', 'error', e);
                    }
                }
            },

            sortOptions(optArray){
                let labels = this.localeSort(optArray.map(opt => opt.label));
                let sortedOptions = [];
                for (let i=0; i<optArray.length; i++) {
                    sortedOptions.push(optArray.find(opt=>opt.label === labels[i]));
                }
                return sortedOptions; // Sort options based on locale
            },

            multiselectChange(value){
                this.value = this.localeSort(value);
                this.saveValue();
            },

            /**
             *
             * @param {number} entityId
             * @param {string} property
             * @param value
             * @param {boolean} isEditor
             */
            async sendChange(entityId, property, value, changeId) {
                return new Promise((resolve, reject)=>{
                    this.$emit('valueChange', {
                        payload: {entityId, simId: this.getSimId, property, value, changeId},
                        promise: {resolve, reject}
                    });
                });
            },

            async getEntities(simId) {
                //const simId = this.simulationId;
                return this.$store.dispatch('callApi', {
                    name: 'getEntities',
                    payload: {simId}
                });

            },

            disable() {
                this.$set(this.cssClass, 'c-input--disable', true);
                this.$set(this.cssClass, 'c-input--success', false);
                this.$set(this.cssClass, 'c-input--error', false);
            },
            success() {
                this.$set(this.cssClass, 'c-input--disable', false);
                this.$set(this.cssClass, 'c-input--success', true);
                this.$set(this.cssClass, 'c-input--error', false);
            },
            error() {
                this.$set(this.cssClass, 'c-input--disable', false);
                this.$set(this.cssClass, 'c-input--success', false);
                this.$set(this.cssClass, 'c-input--error', true);

            },
            clear() {
                this.$set(this.cssClass, 'c-input--disable', false);
                this.$set(this.cssClass, 'c-input--success', false);
                this.$set(this.cssClass, 'c-input--error', false);
                this.change = null;

            },
            undo() {
                if (this.changes.length > 1) {
                    this.changes.pop();
                    this.change = this.changes[this.changes.length - 1];
                } else if (!this.changes.length) {
                    this.change = null;
                }
            },

            testGps(value) {
                var pattern = new RegExp("^[-+]?([1-8]?\\d(\\.\\d+)?|90(\\.0+)?),\\s*[-+]?(180(\\.0+)?|((1[0-7]\\d)|([1-9]?\\d))(\\.\\d+)?)$");
                var pattern2 = new RegExp("[n+N+s+S+e+E+w+W]");
                var patternN = new RegExp("[N+n]");
                var patternE = new RegExp("[E+e]");
                var patternS = new RegExp("[S+s]");
                var patternW = new RegExp("[W+w]");
                if (value == '') {
                    return '0, 0';


                } else if (pattern.exec(value) != null) {
                    return value;

                } else if (pattern2.exec(value) != null) {
                    var newVal = value;

                    if (patternN.exec(value) != null) {
                        newVal = newVal.replace('N', '');
                        newVal = newVal.replace('n', '');
                    }

                    if (patternS.exec(newVal) != null) {
                        newVal = newVal.replace('S', '');
                        newVal = newVal.replace('s', '');
                        newVal = '-' + newVal;
                    }

                    if (patternE.exec(newVal) != null) {
                        newVal = newVal.replace('E', '');
                        newVal = newVal.replace('e', '');
                    }

                    if (patternW.exec(newVal) != null) {
                        newVal = newVal.replace('W', '');
                        newVal = newVal.replace('w', '');
                        newVal = newVal.replace(',', ', -');
                    }

                    if (pattern.exec(newVal) != null) {
                        return newVal;
                    } else {
                        return '0, 0';
                    }

                } else {
                    return '0, 0';
                }


            },
            ...mapActions(['sendCommand']),
        },
        mounted() {
            this.uniq_id = 'form_' + this._uid;
            this.changes.push(this.value);
            this.prevValue = this.value;

            if (this.isScenarioChange) {
                this.$set(this.cssClass, 'c-input--scenario-val', true);
            }

            if (this.inputType === 'select' && this.value === undefined) {
                this.value = this.extension.options[0].value; // choose first item of select if nobody choose before
                this.saveValue();
            }

            if (this.inputType === 'tag' && this.value !== undefined) {
                this.value = this.localeSort(this.value); // Sort values based on locale
                //this.saveValue();
            }

        },
        computed: {
            css() { // přepis class do jednoho objektu
                const cssClasses = {};
                Object.assign(cssClasses, this.cssClass);
                Object.assign(cssClasses, this.$props.dataCss);


                return cssClasses;
            },
            prevValue: {
                get() {
                    return this.prevChange;
                },
                set(value) {
                    this.prevChange = value;
                }
            },
            gps: {
                get() {
                    if (Array.isArray(this.value)) {
                        return GpsFormat.formatGps(this.value);
                    } else {
                        return "";
                    }

                },
                set(value) {
                    const gps = this.testGps(value).split(',');
                    this.value = [Number.parseFloat(gps[0]), Number.parseFloat(gps[1])];
                }

            },
            baseId() {
                return getPropertyValue(this.$props.entity, 'zakladna');
            },
            isEventWaitting() {
                return (this.$store.state.simulation.lists.waitingEvents || []).some(e => e.entityId === this.$props.entity.entityId);
                //return true;
            },
            isEditorMode() {
                return this.$store.state.editMode;
            },
            isScenarioChange() {
                return this.isEditorMode && this.$store.getters.isPropertyScenarioChange(this.dataEntityId, this.dataProperty);
            },
            options() {
                if(this.extension) {
                    let opt = this.extension.options;
                    return this.localeSort(opt) || [];
                } else {
                    return [];
                }
            },
            getSimId() {
                if (this.$route.params.simId === undefined) {
                    return parseInt(this.$store.state.simId);
                } else {
                    return parseInt(this.$route.params.simId);
                }
            }
        }
    }
</script>

<style>
    .label-wrapper label { padding-left: 39px; }
    .input-group-prepend span {font-size: 1.0625em; height: 34px; width: 30px}
    .c-form .form-control { padding: 5px; margin-top: 1px; margin-bottom: 1px;}
    .gps-wrapper div.input-group-prepend {margin: 1px -1px 1px 0;}
    .c-input select {margin-left: 39px}
</style>
